"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../schema");
const value = schema_1.Schema.number()
    .expiration(31536000)
    .unit("umol/L")
    .integer()
    .min(0)
    .max(99999)
    .interpretation({ vocab: "ktx", code: "lab_creatinine" })
    .tag({ vocab: "snomed", code: "113075003", source: "synonym" })
    .tag({ vocab: "loinc", code: "2160-0", source: "synonym" })
    .tag({ vocab: "ktx", code: "lab_procedure" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
